export default "__VITE_ASSET__fnrxxNwQ__"